import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=23607012"
import script from "./photos.ts?vue&type=script&lang=js&external"
export * from "./photos.ts?vue&type=script&lang=js&external"
import style0 from "./photos.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports